import actionCreatorFactory from "../util/redux/action-factory";
import { ReduxDispatch } from "./reducers";
import * as request from "../util/request";
import { env } from "../util/env";
import { showSnackbar } from "./snackbar";

const actionFactory = actionCreatorFactory("HypoMobiili/Feedback");
const sendFeedbackAction = actionFactory<
    { comment: string; score: number },
    void,
    string
>("SEND_FEEDBACK");

export function sendFeedback(comment: string, score: number) {
    return async (dispatch: ReduxDispatch): Promise<void> => {
        try {
            dispatch(sendFeedbackAction({ comment, score }));

            await request.post(`${env.APP_API_HOST}/api/feedback`, {
                score,
                comment,
            });

            dispatch(showSnackbar("Palaute lähetetty"));
        } catch (err) {
            dispatch(showSnackbar("Palautteen lähettäminen epäonnistui"));
            throw err;
        }
    };
}



// WEBPACK FOOTER //
// ./src/ducks/feedback.ts